import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
var FlowButton = function FlowButton(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "button" : _ref$type,
    onClick = _ref.onClick,
    id = _ref.id;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    id: id,
    className: twMerge("outline-none px-4 py-3 bg-primary-new rounded-lg text-center cursor-pointer text-white border-none font-semibold text-base disabled:bg-gray-echo disabled:text-[#979797] disabled:pointer-events-none disabled:cursor-not-allowed", className),
    disabled: disabled,
    type: type,
    onClick: onClick
  }, children));
};
export default FlowButton;